export default __webpack_public_path__ + "static/bg_footer_pc-ad8174534a386a0bd90d68038f5e5734.png";